import { ModalService } from '@app/plugins/iview-modal-modify/service';
import CreateEditForm from '@db/components/recipients/recipients-create-edit-form';
import Export from '@db/components/recipients/recipients-modal-export-db';
import Import from '@db/components/recipients/recipients-modal-import-db';
import i18n from '@app/plugins/i18n';
import { RecipientService } from '@db/services/RecipientService';

class RecipientModalService extends ModalService {
  constructor() {
    super(RecipientService);
  }

  remove(path_params, item) {
    return this.$removeDeepItem(path_params, item, {
      content: i18n.t('db.recipient.modal.remove.content', {
        number: `<strong>${item.number}</strong>`
      })
    });
  }

  edit(database_id, item) {
    return this.$open({
      title: i18n.t('shared.component.modal.edit'),
      render: h =>
        h(CreateEditForm, {
          props: {
            database_id,
            item: item
          },

          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  create(database_id) {
    return this.$open({
      title: i18n.t('shared.component.modal.create'),
      render: h =>
        h(CreateEditForm, {
          props: {
            database_id
          },
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  make_export(database_id) {
    return this.$open({
      title: i18n.t('db.recipient.modal.export.title'),
      render: h =>
        h(Export, {
          props: {
            database_id
          },
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  make_import(database_id, token) {
    return this.$open({
      title: i18n.t('db.recipient.modal.import.title'),
      render: h =>
        h(Import, {
          props: {
            database_id,
            token
          },
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new RecipientModalService();
export { instance as RecipientModalService };
